export default "__VITE_ASSET__kaAXG0Ce__"